import React, { useEffect } from "react";
import styled from "styled-components";


import { FaCode, FaProjectDiagram, FaTasks } from "react-icons/fa";
import imageObj from "../../images/15shots_so1.png";
import back from "../../images/images.PNG";
import { useTranslation } from "react-i18next";
import Aos from "aos";
import PropTypes from "prop-types";

const ServicesSection = styled.section`
  color: #fff;
  background: linear-gradient(
      to bottom,
      #2420 0%,
      #2320 25%,
      #2320 50%,
      #2320 75%,
      #2420 100%
    ),
    url(${back});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  overflow: hidden;
  padding: 50px;

  @media screen and (max-width: 768px) {
    padding: 30px;
  }

  @media screen and (max-width: 480px) {
    padding: 20px;
  }
`;

export const InfoWrapper = styled.div`
  z-index: 1;
  height: 800px;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

const ServicesContainer = styled.div`
  max-width: 600px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: white;

  span {
    color: #18e68e;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #b3b3b3;
  margin-bottom: 30px;

  @media screen and (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const ServiceCard = styled.div`
  display: flex;
  align-items: center;
  background: #161616;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0, 255, 128, 0.2);

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const IconContainer = styled.div`
  background: #18e68e;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;

  svg {
    color: black;
    font-size: 24px;
  }

  @media screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

const ServiceText = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  p {
    font-size: 0.9rem;
    color: #b3b3b3;
  }

  @media screen and (max-width: 768px) {
    h3 {
      font-size: 1rem;
    }

    p {
      font-size: 0.8rem;
    }
  }
`;

const ImageContainer = styled.div`
  img {
    width: 550px;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }
`;

const NosObjectifs = ({ isRTL }) => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);
  const { t } = useTranslation();
  return (
    <ServicesSection id="objectifs" className={isRTL ? "arabe" : ""}>
      <InfoWrapper>
        <ServicesContainer>
          <Title>
            <span>{t("objectives.title")}</span> {t("objectives.title1")}
          </Title>
          <Subtitle>{t("objectives.subtitle")}</Subtitle>

          <ServiceCard data-aos="fade-up">
            <IconContainer style={{ marginLeft: isRTL ? "30px" : "" }}>
              <FaCode />
            </IconContainer>
            <ServiceText>
              <h3>{t("objectives.objectiveTitle1")}</h3>
              <p>{t("objectives.description1")}</p>
            </ServiceText>
          </ServiceCard>

          <ServiceCard data-aos="fade-up" data-aos-delay="100">
            <IconContainer style={{ marginLeft: isRTL ? "30px" : "" }}>
              <FaProjectDiagram />
            </IconContainer>
            <ServiceText>
              <h3>{t("objectives.objectiveTitle2")}</h3>
              <p>{t("objectives.description2")}</p>
            </ServiceText>
          </ServiceCard>

          <ServiceCard data-aos="fade-up" data-aos-delay="200">
            <IconContainer style={{ marginLeft: isRTL ? "30px" : "" }}>
              <FaTasks />
            </IconContainer>
            <ServiceText>
              <h3>{t("objectives.objectiveTitle3")}</h3>
              <p>{t("objectives.description3")}</p>
            </ServiceText>
          </ServiceCard>
        </ServicesContainer>

        <ImageContainer data-aos="fade-left">
          <img src={imageObj} alt="Illustration" />
        </ImageContainer>
      </InfoWrapper>
    </ServicesSection>
  );
};
NosObjectifs.propTypes = {
  isRTL: PropTypes.bool,
};
export default NosObjectifs;
